import { Component } from '@angular/core';
import { LoggingGroupModel, LoggingModel } from 'src/app/models/logging-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: '<app-alert>',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})

export class AlertComponent {

  constructor(public logService: LoggerService) {
  }
}
